import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import {NAVIGATION_MENU} from '../../../core/navigationMenu';

@Component({
  selector: 'vex-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  filtredItems = [];
  items = this.navigationService.items;

  constructor(private navigationService: NavigationService) { }

  ngOnInit() {
  }
}
